function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
export var toMediaQuery = function(minWidth, styles) {
    return _defineProperty({}, "@media (min-width: ".concat(minWidth, "px)"), _objectSpread({}, styles));
};
export var toMaxMediaQuery = function(maxWidth, styles) {
    return _defineProperty({}, "@media (max-width: ".concat(maxWidth, "px)"), _objectSpread({}, styles));
};
function carinaFontReset(theme) {
    return {
        fontFamily: theme.font.base.family,
        fontStyle: 'normal',
        fontWeight: theme.font.base.weight.regular,
        letterSpacing: 'normal',
        lineHeight: theme.font.lineHeight.base,
        textIndent: 0,
        textShadow: 'none',
        textTransform: 'none'
    };
}
export { carinaFontReset };
